/**
 * 描述：获取商户配置信息，由于腾慧和珊瑚两个平台的网校都用该套代码，所以获取配置需要根据平台类型做兼容处理
**/
import axios from 'axios'
import store from "@/store/store"
import GLOBAL_CONFIG from '../../config/index'

/**
 * 描述：获取珊瑚配置信息
**/
export const getShanhuOrgConfig = () => {
    // 先读取腾讯默认配置
    const getDefaultConfig = axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/miniConfig.json?a=${new Date().valueOf()}`)
    // 读取机构单独的配置文件
    const uId = store.getters['user/getOrgId']
    const orgConfig = axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/userConfig/${uId}.json?a=${new Date().valueOf()}`)
    return {
        getDefaultConfig,
        orgConfig
    }
}

/**
 * 描述：获取腾慧配置信息
**/
export const getTengfaceOrgConfig = () => {
    // 先读取阿里默认配置
    const getDefaultConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?a=${new Date().valueOf()}`)
    // 读取机构单独的配置文件
    const uId = store.getters['user/getOrgId']
    const orgConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/userConfig/${uId}.json?a=${new Date().valueOf()}`)
    return {
        getDefaultConfig,
        orgConfig
    }
}

/**
 * 描述：获取机构配置
**/
export const useOrgConfig = () => {
    return new Promise((resolve, reject) => {
        let getRequestBody
        const isShanhu = store.getters['user/getIsShanhuState']
        if(isShanhu) {
            getRequestBody = getShanhuOrgConfig
        } else {
            getRequestBody = getTengfaceOrgConfig
        }
        const { getDefaultConfig, orgConfig } = getRequestBody()
        // 请求后合并配置
        Promise.allSettled([getDefaultConfig, orgConfig]).then(res => {
            try {
                let defaultConfig = {}
                if(res[0].status === 'fulfilled') {
                    defaultConfig = res[0].value.data || {}
                    if (defaultConfig.wx_h5_web_url) {
                        defaultConfig.wx_h5_url = defaultConfig.wx_h5_web_url
                    }
                }
                let orgConfig = {}
                if(res[1].status === 'fulfilled') {
                    orgConfig = res[1].value.data || {}
                }
                const mergeConfig = { ...defaultConfig, ...orgConfig }
                resolve(mergeConfig)
            } catch (error) {
                reject({code: 0, data: error})
            }
        }).catch(err => {
            reject(err)
        })
    })
}